module.exports = __webpack_public_path__ + "static/media/27.0e18f36f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/27.svg
// module id = 138
// module chunks = 0